import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import api from "../services/api";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";
const DEFAULT_PROFILE_IMAGE = `${API_URL}/uploads/default-profile.png`;

export default function OnlineUsersFooter({ contacts = [], socket, currentUserEmail }) {
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [imagesLoaded, setImagesLoaded] = useState({});
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  // Écoute des changements de statut via socket
  useEffect(() => {
    if (!socket) return;

    const handleStatus = (data) => {
      
      // mettre à jour onlineUsers si nécessaire
      setOnlineUsers(prev =>
        prev.map(u => (u._id === data._id ? { ...u, isConnected: data.isConnected } : u))
      );
    };

    socket.on("userStatusChanged", handleStatus);
    return () => socket.off("userStatusChanged", handleStatus);
  }, [socket]);

  // Préchargement des utilisateurs en ligne
  useEffect(() => {
    const fetchOnlineContacts = async () => {
      try {
        if (!contacts?.length) return;

        const response = await api.post(`${API_URL}/api/list_users/online-contacts`, { contacts });
        setOnlineUsers(response.data || []);
      } catch (error) {
        console.error("❌ Erreur récupération contacts connectés :", error);
      }
    };
    fetchOnlineContacts();
  }, [contacts]);

  // Préchargement des images
  useEffect(() => {
    onlineUsers.forEach(user => {
      const img = new Image();
      img.src = user.profileImage
        ? `${API_URL}/api/decryptedFile/decrypted-cloudinary-file/${user._id}?token=${token}&type=image&thumb=true&profile=true&t=${user.profileImageUpdatedAt}`
        : DEFAULT_PROFILE_IMAGE;

      img.onload = () => setImagesLoaded(prev => ({ ...prev, [user._id]: true }));
      img.onerror = () => setImagesLoaded(prev => ({ ...prev, [user._id]: false }));
    });
  }, [onlineUsers, token]);

  if (!onlineUsers.length) return null;

  // Filtrage de l’utilisateur courant et limitation
  const visibleUsers = onlineUsers
    .filter(u => u.email !== currentUserEmail)
    .slice(0, 20);

  return (
    <div
      className="online-footer"
      style={{
        position: "fixed",
        bottom: "0px",
        left: "0px",
        width: "100%",
        zIndex: 60,
        padding: "8px 0",
        background: "var(--bottomtoolbar-bg)",
	color: "var(--text-color)",
        backdropFilter: "blur(6px)",
        
      }}
    >
      <div
        className="online-row"
        style={{
          overflowX: "auto",
          overflowY: "hidden",
          WebkitOverflowScrolling: "touch",
          padding: "0 12px",
          whiteSpace: "nowrap",
        }}
      >
        <div
          style={{
            display: "inline-flex",
            gap: "12px",
            alignItems: "center",
          }}
        >
          {visibleUsers.map(user => (
            <div
              key={user._id}
              className="user-item"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                flex: "0 0 auto",
                minWidth: 64,
                gap: 6,
              }}
            >
              <div style={{ position: "relative" }}>
                <img
                  src={
                    imagesLoaded[user._id]
                      ? (user.profileImage
                          ? `${API_URL}/api/decryptedFile/decrypted-cloudinary-file/${user._id}?token=${token}&type=image&thumb=true&profile=true&t=${user.profileImageUpdatedAt}`
                          : DEFAULT_PROFILE_IMAGE)
                      : DEFAULT_PROFILE_IMAGE
                  }
                  alt={user.username}
                  className="w-10 h-10 rounded-full object-cover border"
                  style={{
                    width: 45,
                    height: 45,
                    borderRadius: "9999px",
                    objectFit: "cover",
                    border: "1px solid rgba(0,0,0,0.06)",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/profile/${user._id}`);
                  }}
                />
                <span
                  style={{
                    position: "absolute",
                    right: -2,
                    bottom: -2,
                    width: 12,
                    height: 12,
                    borderRadius: 12,
                    border: "2px solid white",
                    background: user.isConnected ? "#facc15" : "#9ca3af",
                  }}
                  title={user.isConnected ? "Connecté" : "Déconnecté"}
                />
              </div>
              <div
                style={{
                  fontSize: 11,
                  
                  maxWidth: 64,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {user.username}
              </div>
            </div>
          ))}
          {onlineUsers.length > 20 && (
            <span style={{ fontSize: 12, color: "#555" }}>
              +{onlineUsers.length - 20}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
